(function () {
  class LeavesView extends PIXI.Container {
    constructor() {
      super();
      this._leavesAnimContainer = null;
      this._leavesAnimBase = null;
      this._leavesFSBase = null;
    }

    initialise() {
      const self = this;

      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      const baseName = "leavesContainer:LeavesView";

      this._leavesAnimContainer = resourceManager.get(
        `${baseName}:leavesAnimContainer`
      );

      this._leavesAnimBase = particleManager.createEmitter(
        "FallingLeavesBase",
        this._leavesAnimContainer.name,
        0,
        0,
        false
      );
      this._leavesAnimBase.visible = true;
      this._leavesAnimBase.alpha = 1;
      this._leavesAnimBase.particleEmitter.emit = true;

      this._leavesAnimFS = particleManager.createEmitter(
        "FallingLeavesFS",
        this._leavesAnimContainer.name,
        0,
        0,
        false
      );
      this._leavesAnimFS.visible = false;
      this._leavesAnimFS.particleEmitter.emit = false;
    }

    onFreeSpinsStart() {
      this._leavesAnimBase.particleEmitter.emit = false;
      this._leavesAnimFS.visible = true;
      this._leavesAnimFS.alpha = 1;
      this._leavesAnimFS.particleEmitter.emit = true;

      gsap.fromTo(
        this._leavesAnimBase,
        { alpha: 1 },
        {
          alpha: 0,
          duration: 0.3,
          onComplete: () => {
            this._leavesAnimBase.visible = false;
            this._leavesAnimBase.alpha = 1;
          },
        }
      );
    }

    onFreeSpinsEnd() {
      this._leavesAnimFS.particleEmitter.emit = false;
      this._leavesAnimBase.visible = true;
      this._leavesAnimBase.particleEmitter.emit = true;

      gsap.fromTo(
        this._leavesAnimFS,
        { alpha: 1 },
        {
          alpha: 0,
          duration: 0.3,
          onComplete: () => {
            this._leavesAnimFS.visible = false;
          },
        }
      );
    }
  }

  create = function (json) {
    return new LeavesView();
  };

  initialise = function (json, container, resources) {
    container.initialise();
  };

  getFilesRequired = function (json) {
    return [];
  };

  resourceManager.registerObjectType(
    "LeavesView",
    create,
    initialise,
    getFilesRequired
  );
})();
